import api from '@pray/shared/utils/api';

import type { PlanData, SetupIntentResponse, SetupIntentApiResponse } from './types';

export type UserData = {
  name: string;
  email: string;
};

/**
 * Payment service for handling Stripe-related operations
 */

export const postSetupIntent = async (
  recaptchaToken: string,
  userData: UserData,
  planData: PlanData,
  amount: number,
  currency: string
): Promise<SetupIntentResponse> => {
  const requestBody = {
    recaptcha_token: recaptchaToken,
    user_data: userData,
    plan_data: planData,
    amount,
    currency,
  };

  const response = await api.executePostRequest<SetupIntentApiResponse>(
    '/web/studio/plg/onboarding/payment/intent',
    requestBody
  );

  // Convert from API snake_case to our camelCase
  const apiResponse = response.data;
  return {
    clientSecret: apiResponse.data.client_secret,
  };
};
